unit View.Itens_Saida.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewItens_SaidaList = class(TForm)
    btNew: TButton;
    Itens_SaidaDataset: TXDataWebDataSet;
    Itens_SaidaDatasetid: TIntegerField;
    Itens_SaidaDatasetaliado_id: TIntegerField;
    Itens_SaidaDatasetdata_base_id: TIntegerField;
    Itens_SaidaDatasetvenda_id: TIntegerField;
    Itens_SaidaDatasetproduto_id: TIntegerField;
    Itens_SaidaDatasetunidade_id: TIntegerField;
    Itens_SaidaDatasetitem: TIntegerField;
    Itens_SaidaDatasetcfop_cfop: TStringField;
    Itens_SaidaDatasetquantidade: TFloatField;
    Itens_SaidaDatasetproduto_preco: TFloatField;
    Itens_SaidaDatasetmargem_acrescimo: TFloatField;
    Itens_SaidaDatasetvalor_acrescimo: TFloatField;
    Itens_SaidaDatasetmargem_desconto: TFloatField;
    Itens_SaidaDatasetvalor_desconto: TFloatField;
    Itens_SaidaDatasetvalor_total: TFloatField;
    Itens_SaidaDatasetaliquota_icms: TFloatField;
    Itens_SaidaDatasetvalor_icms: TFloatField;
    Itens_SaidaDatasetaliquota_icms_red: TFloatField;
    Itens_SaidaDatasetvalor_icms_red: TFloatField;
    Itens_SaidaDatasetaliquota_icms_st: TFloatField;
    Itens_SaidaDatasetvalor_icms_st: TFloatField;
    Itens_SaidaDatasetaliquota_ipi: TFloatField;
    Itens_SaidaDatasetvalor_ipi: TFloatField;
    Itens_SaidaDatasetvalor_base_calculo_icms: TFloatField;
    Itens_SaidaDatasetvalor_base_calculo_st: TFloatField;
    Itens_SaidaDatasetcst_id: TStringField;
    Itens_SaidaDatasetvalor_frete: TFloatField;
    Itens_SaidaDatasetvalor_seguro: TFloatField;
    Itens_SaidaDatasetvalor_despesas_acessorias: TFloatField;
    Itens_SaidaDatasetvalor_outras: TFloatField;
    Itens_SaidaDatasetvalor_base_calculo_ipi: TFloatField;
    Itens_SaidaDatasetvalor_base_calculo_pis: TFloatField;
    Itens_SaidaDatasetvalor_pis: TFloatField;
    Itens_SaidaDatasetvalor_base_calculo_cofins: TFloatField;
    Itens_SaidaDatasetvalor_cofins: TFloatField;
    Itens_SaidaDatasetquantidade_selo_ipi: TIntegerField;
    Itens_SaidaDatasetcst_ipi_id: TStringField;
    Itens_SaidaDatasetcsosn_id: TStringField;
    Itens_SaidaDatasetvalor_ipi_unitario: TFloatField;
    Itens_SaidaDatasetaliquota_pis: TFloatField;
    Itens_SaidaDatasetaliquota_cofins: TFloatField;
    Itens_SaidaDatasetcst_pis_id: TStringField;
    Itens_SaidaDatasetcst_cofins_id: TStringField;
    Itens_SaidaDatasetvalor_base_calculo_st_retida: TFloatField;
    Itens_SaidaDatasetvalor_st_retida: TFloatField;
    Itens_SaidaDatasetvalor_pis_retido: TFloatField;
    Itens_SaidaDatasetvalor_cofins_retido: TFloatField;
    Itens_SaidaDatasetcodigo_natureza_pis_cofins_id: TStringField;
    Itens_SaidaDatasetaliquota_id: TIntegerField;
    Itens_SaidaDatasetvalor_isentas: TFloatField;
    Itens_SaidaDatasetproduto_preco_custo: TFloatField;
    Itens_SaidaDatasetcodigo_produto_movimenta_estoque: TIntegerField;
    Itens_SaidaDatasetfuncionario_id: TIntegerField;
    Itens_SaidaDatasetvalor_total_impostos: TFloatField;
    Itens_SaidaDatasetquantidade_embalagem: TIntegerField;
    Itens_SaidaDatasetitem_movimenta_estoque: TBooleanField;
    Itens_SaidaDatasetgrade_produto_id: TIntegerField;
    Itens_SaidaDatasetproduto_nome: TStringField;
    Itens_SaidaDatasetaliquota_interna: TFloatField;
    Itens_SaidaDatasetaliquota_interestadual: TFloatField;
    Itens_SaidaDatasetvalor_base_calculo_icms_interestadual: TFloatField;
    Itens_SaidaDatasetaliquota_icms_interestadual_destino: TFloatField;
    Itens_SaidaDatasetvalor_icms_interestadual_destino: TFloatField;
    Itens_SaidaDatasetvalor_icms_interestadual_remetente: TFloatField;
    Itens_SaidaDatasetaliquota_fcp: TFloatField;
    Itens_SaidaDatasetvalor_fcp: TFloatField;
    Itens_SaidaDatasetnumero_pedido_compra: TStringField;
    Itens_SaidaDatasetitem_pedido_compra: TIntegerField;
    Itens_SaidaDatasetitem_quantidade_movimenta_estoque: TFloatField;
    Itens_SaidaDataseticms_st_recuperado: TBooleanField;
    Itens_SaidaDatasetorigem_csosn_id: TIntegerField;
    Itens_SaidaDatasetpercentual_gnn: TFloatField;
    Itens_SaidaDatasetpercentual_gni: TFloatField;
    Itens_SaidaDatasetpercentual_glp: TFloatField;
    Itens_SaidaDatasetvalor_partida: TFloatField;
    Itens_SaidaDatasetaliquota_st: TFloatField;
    Itens_SaidaDatasetvalor_icms_st_reducao: TFloatField;
    Itens_SaidaDatasetaliquota_st_retida: TFloatField;
    Itens_SaidaDatasetvalor_icms_proprio: TFloatField;
    Itens_SaidaDatasetaliquota_icms_simples_nacional: TFloatField;
    Itens_SaidaDatasetvalor_icms_simples_nacional: TFloatField;
    Itens_SaidaDatasetvalor_icms_desonerado: TFloatField;
    Itens_SaidaDatasetdesoneracao_icms_id: TIntegerField;
    Itens_SaidaDatasetaliquota_ipi_devolvido: TFloatField;
    Itens_SaidaDatasetvalor_ipi_devolvido: TFloatField;
    Itens_SaidaDatasetmotivo_devolucao_ipi: TStringField;
    Itens_SaidaDatasetdesoneracao_icms_st_id: TIntegerField;
    Itens_SaidaDatasetvalor_icms_st_desonerado: TFloatField;
    Itens_SaidaDatasetobservacoes_contribuinte_identificacao: TStringField;
    Itens_SaidaDatasetobservacoes_contribuinte: TStringField;
    Itens_SaidaDatasetobservacoes_fisco_identificacao: TStringField;
    Itens_SaidaDatasetobservacoes_fisco: TStringField;
    Itens_SaidaDatasetcodigo_produto_anvisa: TStringField;
    Itens_SaidaDatasetmotivo_isencao_anvisa: TStringField;
    Itens_SaidaDatasetpreco_maximo_consumidor: TFloatField;
    Itens_SaidaDatasetrastreabilidade_numero_lote: TStringField;
    Itens_SaidaDatasetrastreabilidade_data_fabricacao: TDateTimeField;
    Itens_SaidaDatasetrastreabilidade_data_validade: TDateTimeField;
    Itens_SaidaDatasetrastreabilidade_codigo_agregacao: TStringField;
    Itens_SaidaDatasetvalor_base_calculo_fcp_icms: TFloatField;
    Itens_SaidaDatasetaliquota_fcp_icms: TFloatField;
    Itens_SaidaDatasetvalor_fcp_icms: TFloatField;
    Itens_SaidaDatasetvalor_base_calculo_fcp_st: TFloatField;
    Itens_SaidaDatasetaliquota_fcp_st: TFloatField;
    Itens_SaidaDatasetvalor_fcp_st: TFloatField;
    Itens_SaidaDatasetvalor_base_calculo_fcp_retida: TFloatField;
    Itens_SaidaDatasetaliquota_fcp_retida: TFloatField;
    Itens_SaidaDatasetvalor_fcp_retida: TFloatField;
    Itens_SaidaDatasetinformacoes_adicionais: TStringField;
    Itens_SaidaDatasetquantidade_monofasica: TFloatField;
    Itens_SaidaDatasetaliquota_ad_rem: TFloatField;
    Itens_SaidaDatasetvalor_icms_monofasico: TFloatField;
    Itens_SaidaDatasetquantidade_monofasica_retida: TFloatField;
    Itens_SaidaDatasetaliquota_ad_rem_retida: TFloatField;
    Itens_SaidaDatasetvalor_icms_monofasico_retido: TFloatField;
    Itens_SaidaDatasetcodigo_interno: TIntegerField;
    Itens_SaidaDatasetexcluido: TBooleanField;
    Itens_SaidaDatasetinclusao: TDateTimeField;
    Itens_SaidaDatasetalteracao: TDateTimeField;
    Itens_SaidaDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewItens_SaidaList: TFViewItens_SaidaList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewItens_SaidaList }

procedure TFViewItens_SaidaList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewItens_SaidaList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewItens_SaidaList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewItens_SaidaList, AElementID, Result, @AfterCreate);
end;

procedure TFViewItens_SaidaList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewItens_SaidaList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewItens_SaidaList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Itens_SaidaDataset.Connection.Model.DefaultSchema.FindEntityType(Itens_SaidaDataset.EntitySetName),
      Itens_SaidaDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewItens_SaidaList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('itens_saida', 'active');
  TUtils.SetValorDicionarioClasses('vendas_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_vendas', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Itens_SaidaDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewItens_SaidaList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.itens_saida.list.pagination.info');
  btNew := TButton.Create('view.itens_saida.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.itens_saida.list.table');
  cbPageSize := TComboBox.Create('view.itens_saida.list.cbPageSize');
  edSearch := TEdit.Create('view.itens_saida.list.search');
  lcPaginator := TListControl.Create('view.itens_saida.list.pagination');
  Itens_SaidaDataset := TXDataWebDataSet.Create(Self);
  Itens_SaidaDatasetid := TIntegerField.Create(Self);
  Itens_SaidaDatasetaliado_id := TIntegerField.Create(Self);
  Itens_SaidaDatasetdata_base_id := TIntegerField.Create(Self);
  Itens_SaidaDatasetvenda_id := TIntegerField.Create(Self);
  Itens_SaidaDatasetproduto_id := TIntegerField.Create(Self);
  Itens_SaidaDatasetunidade_id := TIntegerField.Create(Self);
  Itens_SaidaDatasetitem := TIntegerField.Create(Self);
  Itens_SaidaDatasetcfop_cfop := TStringField.Create(Self);
  Itens_SaidaDatasetquantidade := TFloatField.Create(Self);
  Itens_SaidaDatasetproduto_preco := TFloatField.Create(Self);
  Itens_SaidaDatasetmargem_acrescimo := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_acrescimo := TFloatField.Create(Self);
  Itens_SaidaDatasetmargem_desconto := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_desconto := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_total := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_icms := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_icms := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_icms_red := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_icms_red := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_icms_st := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_icms_st := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_ipi := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_ipi := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_base_calculo_icms := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_base_calculo_st := TFloatField.Create(Self);
  Itens_SaidaDatasetcst_id := TStringField.Create(Self);
  Itens_SaidaDatasetvalor_frete := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_seguro := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_despesas_acessorias := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_outras := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_base_calculo_ipi := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_base_calculo_pis := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_pis := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_base_calculo_cofins := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_cofins := TFloatField.Create(Self);
  Itens_SaidaDatasetquantidade_selo_ipi := TIntegerField.Create(Self);
  Itens_SaidaDatasetcst_ipi_id := TStringField.Create(Self);
  Itens_SaidaDatasetcsosn_id := TStringField.Create(Self);
  Itens_SaidaDatasetvalor_ipi_unitario := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_pis := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_cofins := TFloatField.Create(Self);
  Itens_SaidaDatasetcst_pis_id := TStringField.Create(Self);
  Itens_SaidaDatasetcst_cofins_id := TStringField.Create(Self);
  Itens_SaidaDatasetvalor_base_calculo_st_retida := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_st_retida := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_pis_retido := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_cofins_retido := TFloatField.Create(Self);
  Itens_SaidaDatasetcodigo_natureza_pis_cofins_id := TStringField.Create(Self);
  Itens_SaidaDatasetaliquota_id := TIntegerField.Create(Self);
  Itens_SaidaDatasetvalor_isentas := TFloatField.Create(Self);
  Itens_SaidaDatasetproduto_preco_custo := TFloatField.Create(Self);
  Itens_SaidaDatasetcodigo_produto_movimenta_estoque := TIntegerField.Create(Self);
  Itens_SaidaDatasetfuncionario_id := TIntegerField.Create(Self);
  Itens_SaidaDatasetvalor_total_impostos := TFloatField.Create(Self);
  Itens_SaidaDatasetquantidade_embalagem := TIntegerField.Create(Self);
  Itens_SaidaDatasetitem_movimenta_estoque := TBooleanField.Create(Self);
  Itens_SaidaDatasetgrade_produto_id := TIntegerField.Create(Self);
  Itens_SaidaDatasetproduto_nome := TStringField.Create(Self);
  Itens_SaidaDatasetaliquota_interna := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_interestadual := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_base_calculo_icms_interestadual := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_icms_interestadual_destino := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_icms_interestadual_destino := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_icms_interestadual_remetente := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_fcp := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_fcp := TFloatField.Create(Self);
  Itens_SaidaDatasetnumero_pedido_compra := TStringField.Create(Self);
  Itens_SaidaDatasetitem_pedido_compra := TIntegerField.Create(Self);
  Itens_SaidaDatasetitem_quantidade_movimenta_estoque := TFloatField.Create(Self);
  Itens_SaidaDataseticms_st_recuperado := TBooleanField.Create(Self);
  Itens_SaidaDatasetorigem_csosn_id := TIntegerField.Create(Self);
  Itens_SaidaDatasetpercentual_gnn := TFloatField.Create(Self);
  Itens_SaidaDatasetpercentual_gni := TFloatField.Create(Self);
  Itens_SaidaDatasetpercentual_glp := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_partida := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_st := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_icms_st_reducao := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_st_retida := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_icms_proprio := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_icms_simples_nacional := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_icms_simples_nacional := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_icms_desonerado := TFloatField.Create(Self);
  Itens_SaidaDatasetdesoneracao_icms_id := TIntegerField.Create(Self);
  Itens_SaidaDatasetaliquota_ipi_devolvido := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_ipi_devolvido := TFloatField.Create(Self);
  Itens_SaidaDatasetmotivo_devolucao_ipi := TStringField.Create(Self);
  Itens_SaidaDatasetdesoneracao_icms_st_id := TIntegerField.Create(Self);
  Itens_SaidaDatasetvalor_icms_st_desonerado := TFloatField.Create(Self);
  Itens_SaidaDatasetobservacoes_contribuinte_identificacao := TStringField.Create(Self);
  Itens_SaidaDatasetobservacoes_contribuinte := TStringField.Create(Self);
  Itens_SaidaDatasetobservacoes_fisco_identificacao := TStringField.Create(Self);
  Itens_SaidaDatasetobservacoes_fisco := TStringField.Create(Self);
  Itens_SaidaDatasetcodigo_produto_anvisa := TStringField.Create(Self);
  Itens_SaidaDatasetmotivo_isencao_anvisa := TStringField.Create(Self);
  Itens_SaidaDatasetpreco_maximo_consumidor := TFloatField.Create(Self);
  Itens_SaidaDatasetrastreabilidade_numero_lote := TStringField.Create(Self);
  Itens_SaidaDatasetrastreabilidade_data_fabricacao := TDateTimeField.Create(Self);
  Itens_SaidaDatasetrastreabilidade_data_validade := TDateTimeField.Create(Self);
  Itens_SaidaDatasetrastreabilidade_codigo_agregacao := TStringField.Create(Self);
  Itens_SaidaDatasetvalor_base_calculo_fcp_icms := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_fcp_icms := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_fcp_icms := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_base_calculo_fcp_st := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_fcp_st := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_fcp_st := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_base_calculo_fcp_retida := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_fcp_retida := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_fcp_retida := TFloatField.Create(Self);
  Itens_SaidaDatasetinformacoes_adicionais := TStringField.Create(Self);
  Itens_SaidaDatasetquantidade_monofasica := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_ad_rem := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_icms_monofasico := TFloatField.Create(Self);
  Itens_SaidaDatasetquantidade_monofasica_retida := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_ad_rem_retida := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_icms_monofasico_retido := TFloatField.Create(Self);
  Itens_SaidaDatasetcodigo_interno := TIntegerField.Create(Self);
  Itens_SaidaDatasetexcluido := TBooleanField.Create(Self);
  Itens_SaidaDatasetinclusao := TDateTimeField.Create(Self);
  Itens_SaidaDatasetalteracao := TDateTimeField.Create(Self);
  Itens_SaidaDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Itens_SaidaDataset.BeforeLoadDFMValues;
  Itens_SaidaDatasetid.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliado_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetdata_base_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetvenda_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetproduto_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetunidade_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetitem.BeforeLoadDFMValues;
  Itens_SaidaDatasetcfop_cfop.BeforeLoadDFMValues;
  Itens_SaidaDatasetquantidade.BeforeLoadDFMValues;
  Itens_SaidaDatasetproduto_preco.BeforeLoadDFMValues;
  Itens_SaidaDatasetmargem_acrescimo.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_acrescimo.BeforeLoadDFMValues;
  Itens_SaidaDatasetmargem_desconto.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_desconto.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_total.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_icms.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_icms.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_icms_red.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_icms_red.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_icms_st.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_icms_st.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_ipi.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_ipi.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_base_calculo_icms.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_base_calculo_st.BeforeLoadDFMValues;
  Itens_SaidaDatasetcst_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_frete.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_seguro.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_despesas_acessorias.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_outras.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_base_calculo_ipi.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_base_calculo_pis.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_pis.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_base_calculo_cofins.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_cofins.BeforeLoadDFMValues;
  Itens_SaidaDatasetquantidade_selo_ipi.BeforeLoadDFMValues;
  Itens_SaidaDatasetcst_ipi_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetcsosn_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_ipi_unitario.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_pis.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_cofins.BeforeLoadDFMValues;
  Itens_SaidaDatasetcst_pis_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetcst_cofins_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_base_calculo_st_retida.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_st_retida.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_pis_retido.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_cofins_retido.BeforeLoadDFMValues;
  Itens_SaidaDatasetcodigo_natureza_pis_cofins_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_isentas.BeforeLoadDFMValues;
  Itens_SaidaDatasetproduto_preco_custo.BeforeLoadDFMValues;
  Itens_SaidaDatasetcodigo_produto_movimenta_estoque.BeforeLoadDFMValues;
  Itens_SaidaDatasetfuncionario_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_total_impostos.BeforeLoadDFMValues;
  Itens_SaidaDatasetquantidade_embalagem.BeforeLoadDFMValues;
  Itens_SaidaDatasetitem_movimenta_estoque.BeforeLoadDFMValues;
  Itens_SaidaDatasetgrade_produto_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetproduto_nome.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_interna.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_interestadual.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_base_calculo_icms_interestadual.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_icms_interestadual_destino.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_icms_interestadual_destino.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_icms_interestadual_remetente.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_fcp.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_fcp.BeforeLoadDFMValues;
  Itens_SaidaDatasetnumero_pedido_compra.BeforeLoadDFMValues;
  Itens_SaidaDatasetitem_pedido_compra.BeforeLoadDFMValues;
  Itens_SaidaDatasetitem_quantidade_movimenta_estoque.BeforeLoadDFMValues;
  Itens_SaidaDataseticms_st_recuperado.BeforeLoadDFMValues;
  Itens_SaidaDatasetorigem_csosn_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetpercentual_gnn.BeforeLoadDFMValues;
  Itens_SaidaDatasetpercentual_gni.BeforeLoadDFMValues;
  Itens_SaidaDatasetpercentual_glp.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_partida.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_st.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_icms_st_reducao.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_st_retida.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_icms_proprio.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_icms_simples_nacional.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_icms_simples_nacional.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_icms_desonerado.BeforeLoadDFMValues;
  Itens_SaidaDatasetdesoneracao_icms_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_ipi_devolvido.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_ipi_devolvido.BeforeLoadDFMValues;
  Itens_SaidaDatasetmotivo_devolucao_ipi.BeforeLoadDFMValues;
  Itens_SaidaDatasetdesoneracao_icms_st_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_icms_st_desonerado.BeforeLoadDFMValues;
  Itens_SaidaDatasetobservacoes_contribuinte_identificacao.BeforeLoadDFMValues;
  Itens_SaidaDatasetobservacoes_contribuinte.BeforeLoadDFMValues;
  Itens_SaidaDatasetobservacoes_fisco_identificacao.BeforeLoadDFMValues;
  Itens_SaidaDatasetobservacoes_fisco.BeforeLoadDFMValues;
  Itens_SaidaDatasetcodigo_produto_anvisa.BeforeLoadDFMValues;
  Itens_SaidaDatasetmotivo_isencao_anvisa.BeforeLoadDFMValues;
  Itens_SaidaDatasetpreco_maximo_consumidor.BeforeLoadDFMValues;
  Itens_SaidaDatasetrastreabilidade_numero_lote.BeforeLoadDFMValues;
  Itens_SaidaDatasetrastreabilidade_data_fabricacao.BeforeLoadDFMValues;
  Itens_SaidaDatasetrastreabilidade_data_validade.BeforeLoadDFMValues;
  Itens_SaidaDatasetrastreabilidade_codigo_agregacao.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_base_calculo_fcp_icms.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_fcp_icms.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_fcp_icms.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_base_calculo_fcp_st.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_fcp_st.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_fcp_st.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_base_calculo_fcp_retida.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_fcp_retida.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_fcp_retida.BeforeLoadDFMValues;
  Itens_SaidaDatasetinformacoes_adicionais.BeforeLoadDFMValues;
  Itens_SaidaDatasetquantidade_monofasica.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_ad_rem.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_icms_monofasico.BeforeLoadDFMValues;
  Itens_SaidaDatasetquantidade_monofasica_retida.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_ad_rem_retida.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_icms_monofasico_retido.BeforeLoadDFMValues;
  Itens_SaidaDatasetcodigo_interno.BeforeLoadDFMValues;
  Itens_SaidaDatasetexcluido.BeforeLoadDFMValues;
  Itens_SaidaDatasetinclusao.BeforeLoadDFMValues;
  Itens_SaidaDatasetalteracao.BeforeLoadDFMValues;
  Itens_SaidaDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewItens_SaidaList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'venda_id';
      Title := 'venda_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'produto_id';
      Title := 'produto_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'unidade_id';
      Title := 'unidade_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'item';
      Title := 'item';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cfop_cfop';
      Title := 'cfop_cfop';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'quantidade';
      Title := 'quantidade';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'produto_preco';
      Title := 'produto_preco';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'margem_acrescimo';
      Title := 'margem_acrescimo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_acrescimo';
      Title := 'valor_acrescimo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'margem_desconto';
      Title := 'margem_desconto';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_desconto';
      Title := 'valor_desconto';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_total';
      Title := 'valor_total';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliquota_icms';
      Title := 'aliquota_icms';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_icms';
      Title := 'valor_icms';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliquota_icms_red';
      Title := 'aliquota_icms_red';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_icms_red';
      Title := 'valor_icms_red';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliquota_icms_st';
      Title := 'aliquota_icms_st';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_icms_st';
      Title := 'valor_icms_st';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliquota_ipi';
      Title := 'aliquota_ipi';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_ipi';
      Title := 'valor_ipi';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_base_calculo_icms';
      Title := 'valor_base_calculo_icms';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_base_calculo_st';
      Title := 'valor_base_calculo_st';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cst_id';
      Title := 'cst_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_frete';
      Title := 'valor_frete';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_seguro';
      Title := 'valor_seguro';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_despesas_acessorias';
      Title := 'valor_despesas_acessorias';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_outras';
      Title := 'valor_outras';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_base_calculo_ipi';
      Title := 'valor_base_calculo_ipi';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_base_calculo_pis';
      Title := 'valor_base_calculo_pis';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_pis';
      Title := 'valor_pis';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_base_calculo_cofins';
      Title := 'valor_base_calculo_cofins';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_cofins';
      Title := 'valor_cofins';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'quantidade_selo_ipi';
      Title := 'quantidade_selo_ipi';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cst_ipi_id';
      Title := 'cst_ipi_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'csosn_id';
      Title := 'csosn_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_ipi_unitario';
      Title := 'valor_ipi_unitario';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliquota_pis';
      Title := 'aliquota_pis';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliquota_cofins';
      Title := 'aliquota_cofins';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cst_pis_id';
      Title := 'cst_pis_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cst_cofins_id';
      Title := 'cst_cofins_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_base_calculo_st_retida';
      Title := 'valor_base_calculo_st_retida';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_st_retida';
      Title := 'valor_st_retida';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_pis_retido';
      Title := 'valor_pis_retido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_cofins_retido';
      Title := 'valor_cofins_retido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_natureza_pis_cofins_id';
      Title := 'codigo_natureza_pis_cofins_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliquota_id';
      Title := 'aliquota_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_isentas';
      Title := 'valor_isentas';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'produto_preco_custo';
      Title := 'produto_preco_custo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_produto_movimenta_estoque';
      Title := 'codigo_produto_movimenta_estoque';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'funcionario_id';
      Title := 'funcionario_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_total_impostos';
      Title := 'valor_total_impostos';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'quantidade_embalagem';
      Title := 'quantidade_embalagem';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'item_movimenta_estoque';
      Title := 'item_movimenta_estoque';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'grade_produto_id';
      Title := 'grade_produto_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'produto_nome';
      Title := 'produto_nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliquota_interna';
      Title := 'aliquota_interna';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliquota_interestadual';
      Title := 'aliquota_interestadual';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_base_calculo_icms_interestadual';
      Title := 'valor_base_calculo_icms_interestadual';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliquota_icms_interestadual_destino';
      Title := 'aliquota_icms_interestadual_destino';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_icms_interestadual_destino';
      Title := 'valor_icms_interestadual_destino';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_icms_interestadual_remetente';
      Title := 'valor_icms_interestadual_remetente';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliquota_fcp';
      Title := 'aliquota_fcp';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_fcp';
      Title := 'valor_fcp';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'numero_pedido_compra';
      Title := 'numero_pedido_compra';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'item_pedido_compra';
      Title := 'item_pedido_compra';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'item_quantidade_movimenta_estoque';
      Title := 'item_quantidade_movimenta_estoque';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'icms_st_recuperado';
      Title := 'icms_st_recuperado';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'origem_csosn_id';
      Title := 'origem_csosn_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'percentual_gnn';
      Title := 'percentual_gnn';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'percentual_gni';
      Title := 'percentual_gni';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'percentual_glp';
      Title := 'percentual_glp';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_partida';
      Title := 'valor_partida';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliquota_st';
      Title := 'aliquota_st';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_icms_st_reducao';
      Title := 'valor_icms_st_reducao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliquota_st_retida';
      Title := 'aliquota_st_retida';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_icms_proprio';
      Title := 'valor_icms_proprio';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliquota_icms_simples_nacional';
      Title := 'aliquota_icms_simples_nacional';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_icms_simples_nacional';
      Title := 'valor_icms_simples_nacional';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_icms_desonerado';
      Title := 'valor_icms_desonerado';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'desoneracao_icms_id';
      Title := 'desoneracao_icms_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliquota_ipi_devolvido';
      Title := 'aliquota_ipi_devolvido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_ipi_devolvido';
      Title := 'valor_ipi_devolvido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'motivo_devolucao_ipi';
      Title := 'motivo_devolucao_ipi';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'desoneracao_icms_st_id';
      Title := 'desoneracao_icms_st_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_icms_st_desonerado';
      Title := 'valor_icms_st_desonerado';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'observacoes_contribuinte_identificacao';
      Title := 'observacoes_contribuinte_identificacao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'observacoes_contribuinte';
      Title := 'observacoes_contribuinte';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'observacoes_fisco_identificacao';
      Title := 'observacoes_fisco_identificacao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'observacoes_fisco';
      Title := 'observacoes_fisco';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_produto_anvisa';
      Title := 'codigo_produto_anvisa';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'motivo_isencao_anvisa';
      Title := 'motivo_isencao_anvisa';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'preco_maximo_consumidor';
      Title := 'preco_maximo_consumidor';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'rastreabilidade_numero_lote';
      Title := 'rastreabilidade_numero_lote';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'rastreabilidade_data_fabricacao';
      Title := 'rastreabilidade_data_fabricacao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'rastreabilidade_data_validade';
      Title := 'rastreabilidade_data_validade';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'rastreabilidade_codigo_agregacao';
      Title := 'rastreabilidade_codigo_agregacao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_base_calculo_fcp_icms';
      Title := 'valor_base_calculo_fcp_icms';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliquota_fcp_icms';
      Title := 'aliquota_fcp_icms';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_fcp_icms';
      Title := 'valor_fcp_icms';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_base_calculo_fcp_st';
      Title := 'valor_base_calculo_fcp_st';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliquota_fcp_st';
      Title := 'aliquota_fcp_st';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_fcp_st';
      Title := 'valor_fcp_st';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_base_calculo_fcp_retida';
      Title := 'valor_base_calculo_fcp_retida';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliquota_fcp_retida';
      Title := 'aliquota_fcp_retida';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_fcp_retida';
      Title := 'valor_fcp_retida';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'informacoes_adicionais';
      Title := 'informacoes_adicionais';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'quantidade_monofasica';
      Title := 'quantidade_monofasica';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliquota_ad_rem';
      Title := 'aliquota_ad_rem';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_icms_monofasico';
      Title := 'valor_icms_monofasico';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'quantidade_monofasica_retida';
      Title := 'quantidade_monofasica_retida';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliquota_ad_rem_retida';
      Title := 'aliquota_ad_rem_retida';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_icms_monofasico_retido';
      Title := 'valor_icms_monofasico_retido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Itens_SaidaDataset.SetParentComponent(Self);
    Itens_SaidaDataset.Name := 'Itens_SaidaDataset';
    Itens_SaidaDataset.EntitySetName := 'Itens_Saida';
    Itens_SaidaDataset.Connection := DMConnection.ApiConnection;
    Itens_SaidaDataset.Left := 72;
    Itens_SaidaDataset.Top := 144;
    Itens_SaidaDatasetid.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetid.Name := 'Itens_SaidaDatasetid';
    Itens_SaidaDatasetid.FieldName := 'id';
    Itens_SaidaDatasetid.Required := True;
    Itens_SaidaDatasetaliado_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliado_id.Name := 'Itens_SaidaDatasetaliado_id';
    Itens_SaidaDatasetaliado_id.FieldName := 'aliado_id';
    Itens_SaidaDatasetaliado_id.Required := True;
    Itens_SaidaDatasetdata_base_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetdata_base_id.Name := 'Itens_SaidaDatasetdata_base_id';
    Itens_SaidaDatasetdata_base_id.FieldName := 'data_base_id';
    Itens_SaidaDatasetdata_base_id.Required := True;
    Itens_SaidaDatasetvenda_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvenda_id.Name := 'Itens_SaidaDatasetvenda_id';
    Itens_SaidaDatasetvenda_id.FieldName := 'venda_id';
    Itens_SaidaDatasetvenda_id.Required := True;
    Itens_SaidaDatasetproduto_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetproduto_id.Name := 'Itens_SaidaDatasetproduto_id';
    Itens_SaidaDatasetproduto_id.FieldName := 'produto_id';
    Itens_SaidaDatasetproduto_id.Required := True;
    Itens_SaidaDatasetunidade_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetunidade_id.Name := 'Itens_SaidaDatasetunidade_id';
    Itens_SaidaDatasetunidade_id.FieldName := 'unidade_id';
    Itens_SaidaDatasetitem.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetitem.Name := 'Itens_SaidaDatasetitem';
    Itens_SaidaDatasetitem.FieldName := 'item';
    Itens_SaidaDatasetcfop_cfop.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetcfop_cfop.Name := 'Itens_SaidaDatasetcfop_cfop';
    Itens_SaidaDatasetcfop_cfop.FieldName := 'cfop_cfop';
    Itens_SaidaDatasetcfop_cfop.Required := True;
    Itens_SaidaDatasetcfop_cfop.Size := 255;
    Itens_SaidaDatasetquantidade.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetquantidade.Name := 'Itens_SaidaDatasetquantidade';
    Itens_SaidaDatasetquantidade.FieldName := 'quantidade';
    Itens_SaidaDatasetproduto_preco.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetproduto_preco.Name := 'Itens_SaidaDatasetproduto_preco';
    Itens_SaidaDatasetproduto_preco.FieldName := 'produto_preco';
    Itens_SaidaDatasetmargem_acrescimo.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetmargem_acrescimo.Name := 'Itens_SaidaDatasetmargem_acrescimo';
    Itens_SaidaDatasetmargem_acrescimo.FieldName := 'margem_acrescimo';
    Itens_SaidaDatasetvalor_acrescimo.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_acrescimo.Name := 'Itens_SaidaDatasetvalor_acrescimo';
    Itens_SaidaDatasetvalor_acrescimo.FieldName := 'valor_acrescimo';
    Itens_SaidaDatasetmargem_desconto.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetmargem_desconto.Name := 'Itens_SaidaDatasetmargem_desconto';
    Itens_SaidaDatasetmargem_desconto.FieldName := 'margem_desconto';
    Itens_SaidaDatasetvalor_desconto.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_desconto.Name := 'Itens_SaidaDatasetvalor_desconto';
    Itens_SaidaDatasetvalor_desconto.FieldName := 'valor_desconto';
    Itens_SaidaDatasetvalor_total.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_total.Name := 'Itens_SaidaDatasetvalor_total';
    Itens_SaidaDatasetvalor_total.FieldName := 'valor_total';
    Itens_SaidaDatasetvalor_total.Required := True;
    Itens_SaidaDatasetaliquota_icms.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_icms.Name := 'Itens_SaidaDatasetaliquota_icms';
    Itens_SaidaDatasetaliquota_icms.FieldName := 'aliquota_icms';
    Itens_SaidaDatasetvalor_icms.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_icms.Name := 'Itens_SaidaDatasetvalor_icms';
    Itens_SaidaDatasetvalor_icms.FieldName := 'valor_icms';
    Itens_SaidaDatasetaliquota_icms_red.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_icms_red.Name := 'Itens_SaidaDatasetaliquota_icms_red';
    Itens_SaidaDatasetaliquota_icms_red.FieldName := 'aliquota_icms_red';
    Itens_SaidaDatasetvalor_icms_red.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_icms_red.Name := 'Itens_SaidaDatasetvalor_icms_red';
    Itens_SaidaDatasetvalor_icms_red.FieldName := 'valor_icms_red';
    Itens_SaidaDatasetaliquota_icms_st.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_icms_st.Name := 'Itens_SaidaDatasetaliquota_icms_st';
    Itens_SaidaDatasetaliquota_icms_st.FieldName := 'aliquota_icms_st';
    Itens_SaidaDatasetvalor_icms_st.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_icms_st.Name := 'Itens_SaidaDatasetvalor_icms_st';
    Itens_SaidaDatasetvalor_icms_st.FieldName := 'valor_icms_st';
    Itens_SaidaDatasetaliquota_ipi.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_ipi.Name := 'Itens_SaidaDatasetaliquota_ipi';
    Itens_SaidaDatasetaliquota_ipi.FieldName := 'aliquota_ipi';
    Itens_SaidaDatasetvalor_ipi.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_ipi.Name := 'Itens_SaidaDatasetvalor_ipi';
    Itens_SaidaDatasetvalor_ipi.FieldName := 'valor_ipi';
    Itens_SaidaDatasetvalor_base_calculo_icms.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_base_calculo_icms.Name := 'Itens_SaidaDatasetvalor_base_calculo_icms';
    Itens_SaidaDatasetvalor_base_calculo_icms.FieldName := 'valor_base_calculo_icms';
    Itens_SaidaDatasetvalor_base_calculo_st.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_base_calculo_st.Name := 'Itens_SaidaDatasetvalor_base_calculo_st';
    Itens_SaidaDatasetvalor_base_calculo_st.FieldName := 'valor_base_calculo_st';
    Itens_SaidaDatasetcst_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetcst_id.Name := 'Itens_SaidaDatasetcst_id';
    Itens_SaidaDatasetcst_id.FieldName := 'cst_id';
    Itens_SaidaDatasetcst_id.Size := 255;
    Itens_SaidaDatasetvalor_frete.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_frete.Name := 'Itens_SaidaDatasetvalor_frete';
    Itens_SaidaDatasetvalor_frete.FieldName := 'valor_frete';
    Itens_SaidaDatasetvalor_seguro.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_seguro.Name := 'Itens_SaidaDatasetvalor_seguro';
    Itens_SaidaDatasetvalor_seguro.FieldName := 'valor_seguro';
    Itens_SaidaDatasetvalor_despesas_acessorias.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_despesas_acessorias.Name := 'Itens_SaidaDatasetvalor_despesas_acessorias';
    Itens_SaidaDatasetvalor_despesas_acessorias.FieldName := 'valor_despesas_acessorias';
    Itens_SaidaDatasetvalor_outras.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_outras.Name := 'Itens_SaidaDatasetvalor_outras';
    Itens_SaidaDatasetvalor_outras.FieldName := 'valor_outras';
    Itens_SaidaDatasetvalor_base_calculo_ipi.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_base_calculo_ipi.Name := 'Itens_SaidaDatasetvalor_base_calculo_ipi';
    Itens_SaidaDatasetvalor_base_calculo_ipi.FieldName := 'valor_base_calculo_ipi';
    Itens_SaidaDatasetvalor_base_calculo_pis.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_base_calculo_pis.Name := 'Itens_SaidaDatasetvalor_base_calculo_pis';
    Itens_SaidaDatasetvalor_base_calculo_pis.FieldName := 'valor_base_calculo_pis';
    Itens_SaidaDatasetvalor_pis.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_pis.Name := 'Itens_SaidaDatasetvalor_pis';
    Itens_SaidaDatasetvalor_pis.FieldName := 'valor_pis';
    Itens_SaidaDatasetvalor_base_calculo_cofins.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_base_calculo_cofins.Name := 'Itens_SaidaDatasetvalor_base_calculo_cofins';
    Itens_SaidaDatasetvalor_base_calculo_cofins.FieldName := 'valor_base_calculo_cofins';
    Itens_SaidaDatasetvalor_cofins.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_cofins.Name := 'Itens_SaidaDatasetvalor_cofins';
    Itens_SaidaDatasetvalor_cofins.FieldName := 'valor_cofins';
    Itens_SaidaDatasetquantidade_selo_ipi.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetquantidade_selo_ipi.Name := 'Itens_SaidaDatasetquantidade_selo_ipi';
    Itens_SaidaDatasetquantidade_selo_ipi.FieldName := 'quantidade_selo_ipi';
    Itens_SaidaDatasetcst_ipi_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetcst_ipi_id.Name := 'Itens_SaidaDatasetcst_ipi_id';
    Itens_SaidaDatasetcst_ipi_id.FieldName := 'cst_ipi_id';
    Itens_SaidaDatasetcst_ipi_id.Size := 255;
    Itens_SaidaDatasetcsosn_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetcsosn_id.Name := 'Itens_SaidaDatasetcsosn_id';
    Itens_SaidaDatasetcsosn_id.FieldName := 'csosn_id';
    Itens_SaidaDatasetcsosn_id.Size := 255;
    Itens_SaidaDatasetvalor_ipi_unitario.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_ipi_unitario.Name := 'Itens_SaidaDatasetvalor_ipi_unitario';
    Itens_SaidaDatasetvalor_ipi_unitario.FieldName := 'valor_ipi_unitario';
    Itens_SaidaDatasetaliquota_pis.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_pis.Name := 'Itens_SaidaDatasetaliquota_pis';
    Itens_SaidaDatasetaliquota_pis.FieldName := 'aliquota_pis';
    Itens_SaidaDatasetaliquota_cofins.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_cofins.Name := 'Itens_SaidaDatasetaliquota_cofins';
    Itens_SaidaDatasetaliquota_cofins.FieldName := 'aliquota_cofins';
    Itens_SaidaDatasetcst_pis_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetcst_pis_id.Name := 'Itens_SaidaDatasetcst_pis_id';
    Itens_SaidaDatasetcst_pis_id.FieldName := 'cst_pis_id';
    Itens_SaidaDatasetcst_pis_id.Size := 255;
    Itens_SaidaDatasetcst_cofins_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetcst_cofins_id.Name := 'Itens_SaidaDatasetcst_cofins_id';
    Itens_SaidaDatasetcst_cofins_id.FieldName := 'cst_cofins_id';
    Itens_SaidaDatasetcst_cofins_id.Size := 255;
    Itens_SaidaDatasetvalor_base_calculo_st_retida.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_base_calculo_st_retida.Name := 'Itens_SaidaDatasetvalor_base_calculo_st_retida';
    Itens_SaidaDatasetvalor_base_calculo_st_retida.FieldName := 'valor_base_calculo_st_retida';
    Itens_SaidaDatasetvalor_st_retida.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_st_retida.Name := 'Itens_SaidaDatasetvalor_st_retida';
    Itens_SaidaDatasetvalor_st_retida.FieldName := 'valor_st_retida';
    Itens_SaidaDatasetvalor_pis_retido.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_pis_retido.Name := 'Itens_SaidaDatasetvalor_pis_retido';
    Itens_SaidaDatasetvalor_pis_retido.FieldName := 'valor_pis_retido';
    Itens_SaidaDatasetvalor_cofins_retido.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_cofins_retido.Name := 'Itens_SaidaDatasetvalor_cofins_retido';
    Itens_SaidaDatasetvalor_cofins_retido.FieldName := 'valor_cofins_retido';
    Itens_SaidaDatasetcodigo_natureza_pis_cofins_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetcodigo_natureza_pis_cofins_id.Name := 'Itens_SaidaDatasetcodigo_natureza_pis_cofins_id';
    Itens_SaidaDatasetcodigo_natureza_pis_cofins_id.FieldName := 'codigo_natureza_pis_cofins_id';
    Itens_SaidaDatasetcodigo_natureza_pis_cofins_id.Size := 255;
    Itens_SaidaDatasetaliquota_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_id.Name := 'Itens_SaidaDatasetaliquota_id';
    Itens_SaidaDatasetaliquota_id.FieldName := 'aliquota_id';
    Itens_SaidaDatasetvalor_isentas.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_isentas.Name := 'Itens_SaidaDatasetvalor_isentas';
    Itens_SaidaDatasetvalor_isentas.FieldName := 'valor_isentas';
    Itens_SaidaDatasetproduto_preco_custo.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetproduto_preco_custo.Name := 'Itens_SaidaDatasetproduto_preco_custo';
    Itens_SaidaDatasetproduto_preco_custo.FieldName := 'produto_preco_custo';
    Itens_SaidaDatasetcodigo_produto_movimenta_estoque.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetcodigo_produto_movimenta_estoque.Name := 'Itens_SaidaDatasetcodigo_produto_movimenta_estoque';
    Itens_SaidaDatasetcodigo_produto_movimenta_estoque.FieldName := 'codigo_produto_movimenta_estoque';
    Itens_SaidaDatasetfuncionario_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetfuncionario_id.Name := 'Itens_SaidaDatasetfuncionario_id';
    Itens_SaidaDatasetfuncionario_id.FieldName := 'funcionario_id';
    Itens_SaidaDatasetvalor_total_impostos.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_total_impostos.Name := 'Itens_SaidaDatasetvalor_total_impostos';
    Itens_SaidaDatasetvalor_total_impostos.FieldName := 'valor_total_impostos';
    Itens_SaidaDatasetquantidade_embalagem.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetquantidade_embalagem.Name := 'Itens_SaidaDatasetquantidade_embalagem';
    Itens_SaidaDatasetquantidade_embalagem.FieldName := 'quantidade_embalagem';
    Itens_SaidaDatasetitem_movimenta_estoque.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetitem_movimenta_estoque.Name := 'Itens_SaidaDatasetitem_movimenta_estoque';
    Itens_SaidaDatasetitem_movimenta_estoque.FieldName := 'item_movimenta_estoque';
    Itens_SaidaDatasetitem_movimenta_estoque.Required := True;
    Itens_SaidaDatasetgrade_produto_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetgrade_produto_id.Name := 'Itens_SaidaDatasetgrade_produto_id';
    Itens_SaidaDatasetgrade_produto_id.FieldName := 'grade_produto_id';
    Itens_SaidaDatasetproduto_nome.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetproduto_nome.Name := 'Itens_SaidaDatasetproduto_nome';
    Itens_SaidaDatasetproduto_nome.FieldName := 'produto_nome';
    Itens_SaidaDatasetproduto_nome.Size := 255;
    Itens_SaidaDatasetaliquota_interna.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_interna.Name := 'Itens_SaidaDatasetaliquota_interna';
    Itens_SaidaDatasetaliquota_interna.FieldName := 'aliquota_interna';
    Itens_SaidaDatasetaliquota_interestadual.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_interestadual.Name := 'Itens_SaidaDatasetaliquota_interestadual';
    Itens_SaidaDatasetaliquota_interestadual.FieldName := 'aliquota_interestadual';
    Itens_SaidaDatasetvalor_base_calculo_icms_interestadual.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_base_calculo_icms_interestadual.Name := 'Itens_SaidaDatasetvalor_base_calculo_icms_interestadual';
    Itens_SaidaDatasetvalor_base_calculo_icms_interestadual.FieldName := 'valor_base_calculo_icms_interestadual';
    Itens_SaidaDatasetaliquota_icms_interestadual_destino.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_icms_interestadual_destino.Name := 'Itens_SaidaDatasetaliquota_icms_interestadual_destino';
    Itens_SaidaDatasetaliquota_icms_interestadual_destino.FieldName := 'aliquota_icms_interestadual_destino';
    Itens_SaidaDatasetvalor_icms_interestadual_destino.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_icms_interestadual_destino.Name := 'Itens_SaidaDatasetvalor_icms_interestadual_destino';
    Itens_SaidaDatasetvalor_icms_interestadual_destino.FieldName := 'valor_icms_interestadual_destino';
    Itens_SaidaDatasetvalor_icms_interestadual_remetente.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_icms_interestadual_remetente.Name := 'Itens_SaidaDatasetvalor_icms_interestadual_remetente';
    Itens_SaidaDatasetvalor_icms_interestadual_remetente.FieldName := 'valor_icms_interestadual_remetente';
    Itens_SaidaDatasetaliquota_fcp.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_fcp.Name := 'Itens_SaidaDatasetaliquota_fcp';
    Itens_SaidaDatasetaliquota_fcp.FieldName := 'aliquota_fcp';
    Itens_SaidaDatasetvalor_fcp.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_fcp.Name := 'Itens_SaidaDatasetvalor_fcp';
    Itens_SaidaDatasetvalor_fcp.FieldName := 'valor_fcp';
    Itens_SaidaDatasetnumero_pedido_compra.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetnumero_pedido_compra.Name := 'Itens_SaidaDatasetnumero_pedido_compra';
    Itens_SaidaDatasetnumero_pedido_compra.FieldName := 'numero_pedido_compra';
    Itens_SaidaDatasetnumero_pedido_compra.Size := 255;
    Itens_SaidaDatasetitem_pedido_compra.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetitem_pedido_compra.Name := 'Itens_SaidaDatasetitem_pedido_compra';
    Itens_SaidaDatasetitem_pedido_compra.FieldName := 'item_pedido_compra';
    Itens_SaidaDatasetitem_quantidade_movimenta_estoque.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetitem_quantidade_movimenta_estoque.Name := 'Itens_SaidaDatasetitem_quantidade_movimenta_estoque';
    Itens_SaidaDatasetitem_quantidade_movimenta_estoque.FieldName := 'item_quantidade_movimenta_estoque';
    Itens_SaidaDataseticms_st_recuperado.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDataseticms_st_recuperado.Name := 'Itens_SaidaDataseticms_st_recuperado';
    Itens_SaidaDataseticms_st_recuperado.FieldName := 'icms_st_recuperado';
    Itens_SaidaDataseticms_st_recuperado.Required := True;
    Itens_SaidaDatasetorigem_csosn_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetorigem_csosn_id.Name := 'Itens_SaidaDatasetorigem_csosn_id';
    Itens_SaidaDatasetorigem_csosn_id.FieldName := 'origem_csosn_id';
    Itens_SaidaDatasetpercentual_gnn.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetpercentual_gnn.Name := 'Itens_SaidaDatasetpercentual_gnn';
    Itens_SaidaDatasetpercentual_gnn.FieldName := 'percentual_gnn';
    Itens_SaidaDatasetpercentual_gni.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetpercentual_gni.Name := 'Itens_SaidaDatasetpercentual_gni';
    Itens_SaidaDatasetpercentual_gni.FieldName := 'percentual_gni';
    Itens_SaidaDatasetpercentual_glp.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetpercentual_glp.Name := 'Itens_SaidaDatasetpercentual_glp';
    Itens_SaidaDatasetpercentual_glp.FieldName := 'percentual_glp';
    Itens_SaidaDatasetvalor_partida.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_partida.Name := 'Itens_SaidaDatasetvalor_partida';
    Itens_SaidaDatasetvalor_partida.FieldName := 'valor_partida';
    Itens_SaidaDatasetaliquota_st.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_st.Name := 'Itens_SaidaDatasetaliquota_st';
    Itens_SaidaDatasetaliquota_st.FieldName := 'aliquota_st';
    Itens_SaidaDatasetvalor_icms_st_reducao.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_icms_st_reducao.Name := 'Itens_SaidaDatasetvalor_icms_st_reducao';
    Itens_SaidaDatasetvalor_icms_st_reducao.FieldName := 'valor_icms_st_reducao';
    Itens_SaidaDatasetaliquota_st_retida.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_st_retida.Name := 'Itens_SaidaDatasetaliquota_st_retida';
    Itens_SaidaDatasetaliquota_st_retida.FieldName := 'aliquota_st_retida';
    Itens_SaidaDatasetvalor_icms_proprio.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_icms_proprio.Name := 'Itens_SaidaDatasetvalor_icms_proprio';
    Itens_SaidaDatasetvalor_icms_proprio.FieldName := 'valor_icms_proprio';
    Itens_SaidaDatasetaliquota_icms_simples_nacional.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_icms_simples_nacional.Name := 'Itens_SaidaDatasetaliquota_icms_simples_nacional';
    Itens_SaidaDatasetaliquota_icms_simples_nacional.FieldName := 'aliquota_icms_simples_nacional';
    Itens_SaidaDatasetvalor_icms_simples_nacional.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_icms_simples_nacional.Name := 'Itens_SaidaDatasetvalor_icms_simples_nacional';
    Itens_SaidaDatasetvalor_icms_simples_nacional.FieldName := 'valor_icms_simples_nacional';
    Itens_SaidaDatasetvalor_icms_desonerado.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_icms_desonerado.Name := 'Itens_SaidaDatasetvalor_icms_desonerado';
    Itens_SaidaDatasetvalor_icms_desonerado.FieldName := 'valor_icms_desonerado';
    Itens_SaidaDatasetdesoneracao_icms_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetdesoneracao_icms_id.Name := 'Itens_SaidaDatasetdesoneracao_icms_id';
    Itens_SaidaDatasetdesoneracao_icms_id.FieldName := 'desoneracao_icms_id';
    Itens_SaidaDatasetaliquota_ipi_devolvido.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_ipi_devolvido.Name := 'Itens_SaidaDatasetaliquota_ipi_devolvido';
    Itens_SaidaDatasetaliquota_ipi_devolvido.FieldName := 'aliquota_ipi_devolvido';
    Itens_SaidaDatasetvalor_ipi_devolvido.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_ipi_devolvido.Name := 'Itens_SaidaDatasetvalor_ipi_devolvido';
    Itens_SaidaDatasetvalor_ipi_devolvido.FieldName := 'valor_ipi_devolvido';
    Itens_SaidaDatasetmotivo_devolucao_ipi.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetmotivo_devolucao_ipi.Name := 'Itens_SaidaDatasetmotivo_devolucao_ipi';
    Itens_SaidaDatasetmotivo_devolucao_ipi.FieldName := 'motivo_devolucao_ipi';
    Itens_SaidaDatasetmotivo_devolucao_ipi.Size := 255;
    Itens_SaidaDatasetdesoneracao_icms_st_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetdesoneracao_icms_st_id.Name := 'Itens_SaidaDatasetdesoneracao_icms_st_id';
    Itens_SaidaDatasetdesoneracao_icms_st_id.FieldName := 'desoneracao_icms_st_id';
    Itens_SaidaDatasetvalor_icms_st_desonerado.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_icms_st_desonerado.Name := 'Itens_SaidaDatasetvalor_icms_st_desonerado';
    Itens_SaidaDatasetvalor_icms_st_desonerado.FieldName := 'valor_icms_st_desonerado';
    Itens_SaidaDatasetobservacoes_contribuinte_identificacao.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetobservacoes_contribuinte_identificacao.Name := 'Itens_SaidaDatasetobservacoes_contribuinte_identificacao';
    Itens_SaidaDatasetobservacoes_contribuinte_identificacao.FieldName := 'observacoes_contribuinte_identificacao';
    Itens_SaidaDatasetobservacoes_contribuinte_identificacao.Size := 255;
    Itens_SaidaDatasetobservacoes_contribuinte.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetobservacoes_contribuinte.Name := 'Itens_SaidaDatasetobservacoes_contribuinte';
    Itens_SaidaDatasetobservacoes_contribuinte.FieldName := 'observacoes_contribuinte';
    Itens_SaidaDatasetobservacoes_contribuinte.Size := 255;
    Itens_SaidaDatasetobservacoes_fisco_identificacao.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetobservacoes_fisco_identificacao.Name := 'Itens_SaidaDatasetobservacoes_fisco_identificacao';
    Itens_SaidaDatasetobservacoes_fisco_identificacao.FieldName := 'observacoes_fisco_identificacao';
    Itens_SaidaDatasetobservacoes_fisco_identificacao.Size := 255;
    Itens_SaidaDatasetobservacoes_fisco.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetobservacoes_fisco.Name := 'Itens_SaidaDatasetobservacoes_fisco';
    Itens_SaidaDatasetobservacoes_fisco.FieldName := 'observacoes_fisco';
    Itens_SaidaDatasetobservacoes_fisco.Size := 255;
    Itens_SaidaDatasetcodigo_produto_anvisa.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetcodigo_produto_anvisa.Name := 'Itens_SaidaDatasetcodigo_produto_anvisa';
    Itens_SaidaDatasetcodigo_produto_anvisa.FieldName := 'codigo_produto_anvisa';
    Itens_SaidaDatasetcodigo_produto_anvisa.Size := 255;
    Itens_SaidaDatasetmotivo_isencao_anvisa.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetmotivo_isencao_anvisa.Name := 'Itens_SaidaDatasetmotivo_isencao_anvisa';
    Itens_SaidaDatasetmotivo_isencao_anvisa.FieldName := 'motivo_isencao_anvisa';
    Itens_SaidaDatasetmotivo_isencao_anvisa.Size := 255;
    Itens_SaidaDatasetpreco_maximo_consumidor.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetpreco_maximo_consumidor.Name := 'Itens_SaidaDatasetpreco_maximo_consumidor';
    Itens_SaidaDatasetpreco_maximo_consumidor.FieldName := 'preco_maximo_consumidor';
    Itens_SaidaDatasetrastreabilidade_numero_lote.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetrastreabilidade_numero_lote.Name := 'Itens_SaidaDatasetrastreabilidade_numero_lote';
    Itens_SaidaDatasetrastreabilidade_numero_lote.FieldName := 'rastreabilidade_numero_lote';
    Itens_SaidaDatasetrastreabilidade_numero_lote.Size := 255;
    Itens_SaidaDatasetrastreabilidade_data_fabricacao.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetrastreabilidade_data_fabricacao.Name := 'Itens_SaidaDatasetrastreabilidade_data_fabricacao';
    Itens_SaidaDatasetrastreabilidade_data_fabricacao.FieldName := 'rastreabilidade_data_fabricacao';
    Itens_SaidaDatasetrastreabilidade_data_validade.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetrastreabilidade_data_validade.Name := 'Itens_SaidaDatasetrastreabilidade_data_validade';
    Itens_SaidaDatasetrastreabilidade_data_validade.FieldName := 'rastreabilidade_data_validade';
    Itens_SaidaDatasetrastreabilidade_codigo_agregacao.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetrastreabilidade_codigo_agregacao.Name := 'Itens_SaidaDatasetrastreabilidade_codigo_agregacao';
    Itens_SaidaDatasetrastreabilidade_codigo_agregacao.FieldName := 'rastreabilidade_codigo_agregacao';
    Itens_SaidaDatasetrastreabilidade_codigo_agregacao.Size := 255;
    Itens_SaidaDatasetvalor_base_calculo_fcp_icms.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_base_calculo_fcp_icms.Name := 'Itens_SaidaDatasetvalor_base_calculo_fcp_icms';
    Itens_SaidaDatasetvalor_base_calculo_fcp_icms.FieldName := 'valor_base_calculo_fcp_icms';
    Itens_SaidaDatasetaliquota_fcp_icms.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_fcp_icms.Name := 'Itens_SaidaDatasetaliquota_fcp_icms';
    Itens_SaidaDatasetaliquota_fcp_icms.FieldName := 'aliquota_fcp_icms';
    Itens_SaidaDatasetvalor_fcp_icms.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_fcp_icms.Name := 'Itens_SaidaDatasetvalor_fcp_icms';
    Itens_SaidaDatasetvalor_fcp_icms.FieldName := 'valor_fcp_icms';
    Itens_SaidaDatasetvalor_base_calculo_fcp_st.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_base_calculo_fcp_st.Name := 'Itens_SaidaDatasetvalor_base_calculo_fcp_st';
    Itens_SaidaDatasetvalor_base_calculo_fcp_st.FieldName := 'valor_base_calculo_fcp_st';
    Itens_SaidaDatasetaliquota_fcp_st.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_fcp_st.Name := 'Itens_SaidaDatasetaliquota_fcp_st';
    Itens_SaidaDatasetaliquota_fcp_st.FieldName := 'aliquota_fcp_st';
    Itens_SaidaDatasetvalor_fcp_st.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_fcp_st.Name := 'Itens_SaidaDatasetvalor_fcp_st';
    Itens_SaidaDatasetvalor_fcp_st.FieldName := 'valor_fcp_st';
    Itens_SaidaDatasetvalor_base_calculo_fcp_retida.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_base_calculo_fcp_retida.Name := 'Itens_SaidaDatasetvalor_base_calculo_fcp_retida';
    Itens_SaidaDatasetvalor_base_calculo_fcp_retida.FieldName := 'valor_base_calculo_fcp_retida';
    Itens_SaidaDatasetaliquota_fcp_retida.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_fcp_retida.Name := 'Itens_SaidaDatasetaliquota_fcp_retida';
    Itens_SaidaDatasetaliquota_fcp_retida.FieldName := 'aliquota_fcp_retida';
    Itens_SaidaDatasetvalor_fcp_retida.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_fcp_retida.Name := 'Itens_SaidaDatasetvalor_fcp_retida';
    Itens_SaidaDatasetvalor_fcp_retida.FieldName := 'valor_fcp_retida';
    Itens_SaidaDatasetinformacoes_adicionais.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetinformacoes_adicionais.Name := 'Itens_SaidaDatasetinformacoes_adicionais';
    Itens_SaidaDatasetinformacoes_adicionais.FieldName := 'informacoes_adicionais';
    Itens_SaidaDatasetinformacoes_adicionais.Size := 255;
    Itens_SaidaDatasetquantidade_monofasica.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetquantidade_monofasica.Name := 'Itens_SaidaDatasetquantidade_monofasica';
    Itens_SaidaDatasetquantidade_monofasica.FieldName := 'quantidade_monofasica';
    Itens_SaidaDatasetaliquota_ad_rem.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_ad_rem.Name := 'Itens_SaidaDatasetaliquota_ad_rem';
    Itens_SaidaDatasetaliquota_ad_rem.FieldName := 'aliquota_ad_rem';
    Itens_SaidaDatasetvalor_icms_monofasico.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_icms_monofasico.Name := 'Itens_SaidaDatasetvalor_icms_monofasico';
    Itens_SaidaDatasetvalor_icms_monofasico.FieldName := 'valor_icms_monofasico';
    Itens_SaidaDatasetquantidade_monofasica_retida.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetquantidade_monofasica_retida.Name := 'Itens_SaidaDatasetquantidade_monofasica_retida';
    Itens_SaidaDatasetquantidade_monofasica_retida.FieldName := 'quantidade_monofasica_retida';
    Itens_SaidaDatasetaliquota_ad_rem_retida.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_ad_rem_retida.Name := 'Itens_SaidaDatasetaliquota_ad_rem_retida';
    Itens_SaidaDatasetaliquota_ad_rem_retida.FieldName := 'aliquota_ad_rem_retida';
    Itens_SaidaDatasetvalor_icms_monofasico_retido.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_icms_monofasico_retido.Name := 'Itens_SaidaDatasetvalor_icms_monofasico_retido';
    Itens_SaidaDatasetvalor_icms_monofasico_retido.FieldName := 'valor_icms_monofasico_retido';
    Itens_SaidaDatasetcodigo_interno.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetcodigo_interno.Name := 'Itens_SaidaDatasetcodigo_interno';
    Itens_SaidaDatasetcodigo_interno.FieldName := 'codigo_interno';
    Itens_SaidaDatasetcodigo_interno.Required := True;
    Itens_SaidaDatasetexcluido.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetexcluido.Name := 'Itens_SaidaDatasetexcluido';
    Itens_SaidaDatasetexcluido.FieldName := 'excluido';
    Itens_SaidaDatasetinclusao.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetinclusao.Name := 'Itens_SaidaDatasetinclusao';
    Itens_SaidaDatasetinclusao.FieldName := 'inclusao';
    Itens_SaidaDatasetalteracao.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetalteracao.Name := 'Itens_SaidaDatasetalteracao';
    Itens_SaidaDatasetalteracao.FieldName := 'alteracao';
    Itens_SaidaDatasetexclusao.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetexclusao.Name := 'Itens_SaidaDatasetexclusao';
    Itens_SaidaDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Itens_SaidaDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Itens_SaidaDataset.AfterLoadDFMValues;
    Itens_SaidaDatasetid.AfterLoadDFMValues;
    Itens_SaidaDatasetaliado_id.AfterLoadDFMValues;
    Itens_SaidaDatasetdata_base_id.AfterLoadDFMValues;
    Itens_SaidaDatasetvenda_id.AfterLoadDFMValues;
    Itens_SaidaDatasetproduto_id.AfterLoadDFMValues;
    Itens_SaidaDatasetunidade_id.AfterLoadDFMValues;
    Itens_SaidaDatasetitem.AfterLoadDFMValues;
    Itens_SaidaDatasetcfop_cfop.AfterLoadDFMValues;
    Itens_SaidaDatasetquantidade.AfterLoadDFMValues;
    Itens_SaidaDatasetproduto_preco.AfterLoadDFMValues;
    Itens_SaidaDatasetmargem_acrescimo.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_acrescimo.AfterLoadDFMValues;
    Itens_SaidaDatasetmargem_desconto.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_desconto.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_total.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_icms.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_icms.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_icms_red.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_icms_red.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_icms_st.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_icms_st.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_ipi.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_ipi.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_base_calculo_icms.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_base_calculo_st.AfterLoadDFMValues;
    Itens_SaidaDatasetcst_id.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_frete.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_seguro.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_despesas_acessorias.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_outras.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_base_calculo_ipi.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_base_calculo_pis.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_pis.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_base_calculo_cofins.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_cofins.AfterLoadDFMValues;
    Itens_SaidaDatasetquantidade_selo_ipi.AfterLoadDFMValues;
    Itens_SaidaDatasetcst_ipi_id.AfterLoadDFMValues;
    Itens_SaidaDatasetcsosn_id.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_ipi_unitario.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_pis.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_cofins.AfterLoadDFMValues;
    Itens_SaidaDatasetcst_pis_id.AfterLoadDFMValues;
    Itens_SaidaDatasetcst_cofins_id.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_base_calculo_st_retida.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_st_retida.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_pis_retido.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_cofins_retido.AfterLoadDFMValues;
    Itens_SaidaDatasetcodigo_natureza_pis_cofins_id.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_id.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_isentas.AfterLoadDFMValues;
    Itens_SaidaDatasetproduto_preco_custo.AfterLoadDFMValues;
    Itens_SaidaDatasetcodigo_produto_movimenta_estoque.AfterLoadDFMValues;
    Itens_SaidaDatasetfuncionario_id.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_total_impostos.AfterLoadDFMValues;
    Itens_SaidaDatasetquantidade_embalagem.AfterLoadDFMValues;
    Itens_SaidaDatasetitem_movimenta_estoque.AfterLoadDFMValues;
    Itens_SaidaDatasetgrade_produto_id.AfterLoadDFMValues;
    Itens_SaidaDatasetproduto_nome.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_interna.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_interestadual.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_base_calculo_icms_interestadual.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_icms_interestadual_destino.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_icms_interestadual_destino.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_icms_interestadual_remetente.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_fcp.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_fcp.AfterLoadDFMValues;
    Itens_SaidaDatasetnumero_pedido_compra.AfterLoadDFMValues;
    Itens_SaidaDatasetitem_pedido_compra.AfterLoadDFMValues;
    Itens_SaidaDatasetitem_quantidade_movimenta_estoque.AfterLoadDFMValues;
    Itens_SaidaDataseticms_st_recuperado.AfterLoadDFMValues;
    Itens_SaidaDatasetorigem_csosn_id.AfterLoadDFMValues;
    Itens_SaidaDatasetpercentual_gnn.AfterLoadDFMValues;
    Itens_SaidaDatasetpercentual_gni.AfterLoadDFMValues;
    Itens_SaidaDatasetpercentual_glp.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_partida.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_st.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_icms_st_reducao.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_st_retida.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_icms_proprio.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_icms_simples_nacional.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_icms_simples_nacional.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_icms_desonerado.AfterLoadDFMValues;
    Itens_SaidaDatasetdesoneracao_icms_id.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_ipi_devolvido.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_ipi_devolvido.AfterLoadDFMValues;
    Itens_SaidaDatasetmotivo_devolucao_ipi.AfterLoadDFMValues;
    Itens_SaidaDatasetdesoneracao_icms_st_id.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_icms_st_desonerado.AfterLoadDFMValues;
    Itens_SaidaDatasetobservacoes_contribuinte_identificacao.AfterLoadDFMValues;
    Itens_SaidaDatasetobservacoes_contribuinte.AfterLoadDFMValues;
    Itens_SaidaDatasetobservacoes_fisco_identificacao.AfterLoadDFMValues;
    Itens_SaidaDatasetobservacoes_fisco.AfterLoadDFMValues;
    Itens_SaidaDatasetcodigo_produto_anvisa.AfterLoadDFMValues;
    Itens_SaidaDatasetmotivo_isencao_anvisa.AfterLoadDFMValues;
    Itens_SaidaDatasetpreco_maximo_consumidor.AfterLoadDFMValues;
    Itens_SaidaDatasetrastreabilidade_numero_lote.AfterLoadDFMValues;
    Itens_SaidaDatasetrastreabilidade_data_fabricacao.AfterLoadDFMValues;
    Itens_SaidaDatasetrastreabilidade_data_validade.AfterLoadDFMValues;
    Itens_SaidaDatasetrastreabilidade_codigo_agregacao.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_base_calculo_fcp_icms.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_fcp_icms.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_fcp_icms.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_base_calculo_fcp_st.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_fcp_st.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_fcp_st.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_base_calculo_fcp_retida.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_fcp_retida.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_fcp_retida.AfterLoadDFMValues;
    Itens_SaidaDatasetinformacoes_adicionais.AfterLoadDFMValues;
    Itens_SaidaDatasetquantidade_monofasica.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_ad_rem.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_icms_monofasico.AfterLoadDFMValues;
    Itens_SaidaDatasetquantidade_monofasica_retida.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_ad_rem_retida.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_icms_monofasico_retido.AfterLoadDFMValues;
    Itens_SaidaDatasetcodigo_interno.AfterLoadDFMValues;
    Itens_SaidaDatasetexcluido.AfterLoadDFMValues;
    Itens_SaidaDatasetinclusao.AfterLoadDFMValues;
    Itens_SaidaDatasetalteracao.AfterLoadDFMValues;
    Itens_SaidaDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
